<template>
  <div id="app" :class="makeSafeForCSS($route.name)">
    <Layout />
  </div>
</template>

<script>
import axios from "axios";
import Layout from "@/components/Layout/Layout";

export default {
  name: "app",
  components: {
    Layout,
  },
  async created() {
    if(this.$route.name === 'Authenticate') {
      //in auth route so don't call getUser
    } else {
      const response = await axios.get("user/getUser");

      if (localStorage.getItem("token")) {
        this.$store.dispatch("user", response.data);
      }
    }
  },
  data() {
    return {
      inactivityTimeout:-1,
      inactivityWarningTimeout:-1,
      duration:120 * 60 * 1000 //15 minutes
    };
  },
  mounted() {},
  updated() {
    if(localStorage.getItem('token') == (null || undefined)){
      //not logged in
    }else{
      this.startInactivityTimeout();
    }    
  },
  methods: {
    startInactivityTimeout() {
      if(this.inactivityWarningTimeout >= 0) {
        clearTimeout(this.inactivityWarningTimeout);
      }
      if(this.inactivityTimeout >= 0) {
        clearTimeout(this.inactivityTimeout);
      }
      this.inactivityWarningTimeout = setTimeout(this.warn, this.duration - (60 * 1000 * 5)); //5 minute warning
      this.inactivityTimeout = setTimeout(this.logout, this.duration); 
    },
    keepLoggedIn(result) {
        if (result.value) {          
          this.startInactivityTimeout();
      }
    },
    warn() {
      this.$swal({
        title: 'Warning',
        text: "You've been inactive for a while and you will be logged out soon",
        type: 'warning',    
        confirmButtonText: 'Keep me logged in'
      }).then(this.keepLoggedIn);     
    },
    logout() {
      localStorage.removeItem("token");
      this.$store.dispatch("user", null);
      this.$router.push("/login");
      this.$store.dispatch("mobileMenu", false);
      this.$swal.close();
    },
    makeSafeForCSS(name) {
      return name.replace(/[^a-z0-9]/g, function (s) {
        var c = s.charCodeAt(0);
        if (c == 32) return "-";
        if (c >= 65 && c <= 90) return "_" + s.toLowerCase();
        return "__" + ("000" + c.toString(16)).slice(-4);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
  // overflow: auto;
}
</style>
